import { render, staticRenderFns } from "./SetupCompanyDone.vue?vue&type=template&id=72dc780e&scoped=true"
import script from "./SetupCompanyDone.vue?vue&type=script&lang=js"
export * from "./SetupCompanyDone.vue?vue&type=script&lang=js"
import style0 from "./SetupCompanyDone.vue?vue&type=style&index=0&id=72dc780e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dc780e",
  null
  
)

export default component.exports